import React from 'react';
import './UI.css';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'outline';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  className,
  children,
  ...rest
}) => {
  return (
    <button
      className={`ns-btn ns-btn-${variant} ${className ?? ''}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
};


